import React, {useCallback} from "react";
import { Button, Tooltip, UncontrolledTooltip } from "reactstrap";
import { Edit, Edit2, Flag, Heart, Mail, MessageSquare } from "react-feather";

import EditProduct from "../../Pages/Product/Components/EditProduct";
import mixpanel from 'mixpanel-browser';
import { MIXPANEL_PRODUCTS_VIDEOS_CARD } from '../../mixpanel/mixpanel_constants'

const NoteText = ({
  text,
  update,
  submit,
  isCreator,
  influencerDetailPage,
}) => (
  <div
    className="note"
    style={{
      right: isCreator === "creators" ? "0px" : "",
      ...(influencerDetailPage ? { left: "0px" } : {}),
    }}
  >
    <div className="note-header">Note</div>
    <textarea className="note-input" value={text} onChange={update} />
    <span role="button" className="note-button" onClick={submit}>
      Save
    </span>
  </div>
);

/* eslint-disable */
class NoteContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openEditProduct: false,
      mailTooltipOpen: false,
      chatTooltipOpen: false,
      favTooltipOpen: false,
      flagTooltipOpen: false,
      editTooltipOpen: false,
      editProductTooltipOpen: false,
      text: props.note ? props.note.note : "",
    };
    this.mailToggle = this.mailToggle.bind(this);
    this.chatToggle = this.chatToggle.bind(this);
    this.favtoggle = this.favtoggle.bind(this);
    this.flagtoggle = this.flagtoggle.bind(this);
    this.editToggle = this.editToggle.bind(this);
    this.editProToggle = this.editProToggle.bind(this);
  }

  componentDidUpdate({ note }) {
    this.setState({ text: note ? note.note : "" });
  }

  toggleOpen = () => {
    this.setState({ open: !this.state.open });
    if (!this.state.open) mixpanel.track(MIXPANEL_PRODUCTS_VIDEOS_CARD.OPEN_EDIT_NOTE_DIALOG)
  };

  updateText = ({ target }) => {
    this.setState({ text: target.value });
  };

  toggle = (field) => () => {
    const { id, note, updateNote } = this.props;

    // Mixpanel tracking for Favorite
    switch (field) {
      case "flagged":
        const flagged = note.flagged || note.flagged_video;
        mixpanel.track(MIXPANEL_PRODUCTS_VIDEOS_CARD.FLAG)
        return updateNote(id, { flagged: !flagged });
      case "favorite":
        mixpanel.track(MIXPANEL_PRODUCTS_VIDEOS_CARD.ADD_TO_FAVORITES)
        break;
    }
    updateNote(id, { [field]: !note[field] });
  };

  submitText = () => {
    const { id, updateNote } = this.props;
    updateNote(id, { note: this.state.text });
    this.toggleOpen();
    mixpanel.track(MIXPANEL_PRODUCTS_VIDEOS_CARD.SUBMIT_EDIT_NOTE)
  };

  showProductEdit = () => {
    this.setState({ openEditProduct: !this.state.openEditProduct });
    if (!this.state.openEditProduct) mixpanel.track(MIXPANEL_PRODUCTS_VIDEOS_CARD.EDIT_PRODUCT)
  };

  mailToggle = () => {
    this.setState({
      mailTooltipOpen: !this.state.mailTooltipOpen,
    });
  };

  chatToggle = () => {
    this.setState({
      chatTooltipOpen: !this.state.chatTooltipOpen,
    });
  };

  favtoggle = () => {
    this.setState({
      favTooltipOpen: !this.state.favTooltipOpen,
    });
  };

  flagtoggle = () => {
    this.setState({
      flagTooltipOpen: !this.state.flagTooltipOpen,
    });
  };

  editToggle = () => {
    this.setState({
      editTooltipOpen: !this.state.editTooltipOpen,
    });
  };

  editProToggle = () => {
    this.setState({
      editProductTooltipOpen: !this.state.editProductTooltipOpen,
    });
  };

  render() {
    const {
      isInfluencer,
      note,
      isTryAndBuy,
      handleCopyText,
      id,
      manufacturer_id,
      current_brand,
      current_user,
      product_edit,
      title,
      isEmailCopied,
      isEmailBlocked,
      isCreatorNote,
      is_index,
      tab,
      influencerDetailPage,
    } = this.props;
    const current_id = current_brand
      ? current_brand._id
      : current_user
      ? current_user._id
      : "";
    const { open, text, openEditProduct } = this.state;

    const handleEmailClick =() => {
      mixpanel.track(MIXPANEL_PRODUCTS_VIDEOS_CARD.COPY_EMAIL)
      handleCopyText()
    }

    return (
      <div className="d-flex justify-content-between">
        {isInfluencer && (
          <>
            <div>
              <span
                role="button"
                id={`mail${id}`}
                onClick={isEmailBlocked ? () => {} : handleEmailClick}
              >
                <Mail
                  size={15}
                  color={
                    isEmailBlocked
                      ? "lightgrey"
                      : isEmailCopied
                      ? "red"
                      : "#808080"
                  }
                />{" "}
              </span>
              <UncontrolledTooltip
                placement="top"
                target={`mail${id}`}
                arrow="true"
              >
                {title}
              </UncontrolledTooltip>
            </div>
          </>
        )}
        <div>
          <span role="button" id={`fav${id}`} onClick={this.toggle("favorite")}>
            <Heart
              size={15}
              color={note && note.favorite ? "#E62580" : "#808080"}
              fill={note && note.favorite ? "#E62580" : "white"}
            />{" "}
          </span>
          <Tooltip
            placement="top"
            target={`fav${id}`}
            arrow="true"
            isOpen={this.state.favTooltipOpen}
            toggle={this.favtoggle}
          >
            {note && note.favorite
              ? "Remove from Favorites"
              : "Add to Favorites"}
          </Tooltip>
        </div>
        <div className={`${is_index && "ms-1 me-1"}`}>
          <span role="button" id={`flag${id}`} onClick={this.toggle("flagged")}>
            <Flag
              size={15}
              color={
                (note && note.flagged) || (note && note.flagged_video)
                  ? "#e67c19"
                  : "#808080"
              }
            />{" "}
          </span>
          <Tooltip
            placement="top"
            target={`flag${id}`}
            arrow="true"
            isOpen={this.state.flagTooltipOpen}
            toggle={this.flagtoggle}
          >
            {(note && note.flagged) || (note && note.flagged_video)
              ? "Unflag"
              : "Flag"}
          </Tooltip>
        </div>

        {is_index ? (
          ""
        ) : (
          <div className="note-container">
            <span role="button" id={`edit${id}`} onClick={this.toggleOpen}>
              <Edit size={17} color={text ? "#6428e5" : "#989898"} />{" "}
            </span>
            <Tooltip
              placement="top"
              target={`edit${id}`}
              arrow="true"
              isOpen={this.state.editTooltipOpen}
              toggle={this.editToggle}
            >
              Edit Note
            </Tooltip>
            {open ? (
              <NoteText
                text={text}
                update={this.updateText}
                submit={this.submitText}
                isCreator={isCreatorNote}
                influencerDetailPage={influencerDetailPage}
              />
            ) : null}
          </div>
        )}
        {/* {(manufacturer_id === current_id) ? ( */}
        {product_edit ? (
          <div>
            <span
              role="button"
              id={`editPro${id}`}
              onClick={this.showProductEdit}
            >
              <Edit2 size={15} color="#989898" />
            </span>
            <Tooltip
              placement="top"
              target={`editPro${id}`}
              arrow="true"
              isOpen={this.state.editProductTooltipOpen}
              toggle={this.editProToggle}
            >
              Edit
            </Tooltip>
            {openEditProduct && (
              <EditProduct
                product_id={id}
                open={openEditProduct}
                showProductEdit={this.showProductEdit}
                tab={tab}
              />
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default NoteContainer;
